
import {
  serviceFeatures,
  popularServices,
  services,
  questions,
  uses,
  dnsUses,
  scrubbingCenter,
  locations,
} from "~/data/disasterRecovery";
import Usage from "~/components/disasterRecovery/Usage.vue";
import Uses from "~/components/disasterRecovery/Uses.vue";
import Modal from "~/components/rebranding/modal/Modal.vue";

export default {
  components: {
    Uses,
    Usage,
    Modal,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "بازیابی از بحران سازمانی | Disaster Recovery آبالون",
      meta: [
        {
          name: "description",
          content:
            "بازیابی از بحران | منطبق بر الزامات پدافند غیرعامل | متناسب با معماری زیرساخت سازمان شما | پیاده‌سازی توسط متخصصان ابری | Disaster Recovery آبالون",
        },
        {
          name: "keywords",
          content: "بکاپ سرور",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/backup-solutions",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "بازیابی از بحران سازمانی | Disaster Recovery آبالون",
        },
        {
          property: "og:description",
          content:
            "بازیابی از بحران | منطبق بر الزامات پدافند غیرعامل | متناسب با معماری زیرساخت سازمان شما | پیاده‌سازی توسط متخصصان ابری | Disaster Recovery آبالون",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/backup-solutions",
        },
        {
          name: "twitter:title",
          title: "بازیابی از بحران سازمانی | Disaster Recovery آبالون",
        },
        {
          name: "twitter:description",
          content:
            "بازیابی از بحران | منطبق بر الزامات پدافند غیرعامل | متناسب با معماری زیرساخت سازمان شما | پیاده‌سازی توسط متخصصان ابری | Disaster Recovery آبالون",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/backup-solutions",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "امکان انتخاب محل دیتاسنتر بازیابی از بحران چگونه فراهم می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "آبالون با در اختیار داشتن بیش از ۲۰ دیتاسنتر در سراسر کشور، این امکان را فراهم می‌کند که سرویس DR در مکان‌هایی با فاصله جغرافیایی مناسب و مطابق الزامات پدافند غیرعامل طراحی و پیاده‌سازی شود.",
                },
              },
              {
                "@type": "Question",
                name: "راهکار بازیابی از بحران آبالون برای چه سازمان‌هایی مناسب است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "راهکار بازیابی از بحران آبالون برای سازمان‌هایی مناسب است که نیاز به تداوم خدمات در شرایط بحرانی و حفظ دسترسی به داده‌های خود دارند. این راهکار بر اساس معماری زیرساخت سازمان قابل پیاده‌سازی است.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان پیاده‌سازی سناریوهای Active-Active و Active-Passive وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، آبالون با توجه به نیاز و مقیاس سازمان‌ها، امکان راه‌اندازی سناریوهای Active-Active و Active-Passive را در راهکار بازیابی از بحران فراهم می‌کند تا سرویس‌ها در زمان وقوع اختلال بدون توقف یا با کمترین توقف ادامه پیدا کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان استفاده از لینک ارتباطی سریع برای انتقال داده بین سایت اصلی و سایت DR وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، آبالون با بهره‌گیری از شبکه اختصاصی نورونتا، امکان ارائه لینک‌های ارتباطی ایزوله و غیر اشتراکی با سرعت بالا تا چند ده گیگابیت بر ثانیه را بین دیتاسنترها یا از محل سازمان تا دیتاسنتر فراهم نموده است. این قابلیت برای سناریوهای Active-Active و Active-Passive ایده‌آل است.",
                },
              },
            ],
          },
        },
      ],
    };
  },
  data() {
    return {
      dnsUses,
      uses,
      scrubbingCenter,
      popularServices,
      questions,
      locations,
      title: "بازیابی از بحران سازمانی | Disaster Recovery آبالون",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      activeSection: "",
      tab: 0,
      solotionTab: 0,
      showmore: false,
    };
  },
  mounted() {},
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
};
